// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../images/common/icons.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.D9DWeQ6vl26go5aEPQro {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background-color: white;
    padding: 0.25rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    max-width: 430px;
}

.dpCPxzE5HTyFWPOxQtDQ {
    text-align: center;
}

.G4FKZ5da2A7yrkGWDEix {
    position: relative;
    height: 640px;
    border-width: 2px;
    border-style: solid;
    border-color: #dedede;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    border-radius: 1rem;
    overflow-y: auto;
    background-color: #f9f9f9;
}

.sEJkCycmk5b1OyetRw4K {
    margin: 0;
    margin-top: 0.25rem;
    padding: 0.25rem;
}

.orhOQFkVQCn95ohirr24 {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding-left: 0.65rem;
    padding-right: 0.65rem;
    margin-bottom: 0.5rem;
}

.A3rjX5eCVNYkauQiOpWT {
    display: block;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 0.5px;
    align-items: center;
    color: #101828;
    font-family: "Metropolis";
    font-weight: 600;
}

.y54A11MhSaIVi5Mr315E {
    font-size: 11px;
    font-family: 'Metropolis', sans-serif;
    font-weight: 500;
    line-height: 1rem;
    padding-bottom: 0.25rem;
    color: #000000;
}


.Ap677P7vecKEtQx7kbPM {
    box-sizing: border-box;
    border-radius: 12px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid #eaecf0;
    position: relative;
    padding-bottom: 0.5rem;
}

.zDHFAYa5ECa16AfBvGPH {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 0.675rem 0.5rem 0.675rem;
}

.BGuZZqt6D1__g0TUjRD5 {
    display: flex;
    gap: 4px;
    font-weight: 600;
}

.BGuZZqt6D1__g0TUjRD5 .fsLOdANtgZTVUAoJLc7W {
    max-height: 23px;
    max-width: 20px;
    overflow: hidden;
}

.BGuZZqt6D1__g0TUjRD5 .EYvM_eEq3ZcKb4ZxuvIa {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    font-size: 13px;
    text-align: left;
}

.U0ywxzShWByb0EqWeDIQ {
    font-size: 0.8rem;
    display: flex;
    align-items: end;
    gap: 0.25rem;
    color: inherit;
}

.iFrIGiyZWXtfzzHWIolk {
    display: flex;
    flex-direction: column;
}

.mJbUqtDQwPWMUbApCQYJ {
    font-size: 10px;
    text-align: left;
    text-decoration: line-through;
}

.HqYT8bZZB9iZggDTVmak {
    width: 0.7rem;
    height: 1rem;
    overflow: hidden;
    transform: scale(0.85);
}

.bAEDwJv1xxKkiHdLTK8r {
    background: white;
    border-radius: 8px;
    padding-bottom: 0.5rem;
}

._Muhqa_ya7ekdsu68zdQ {
    display: flex;
    padding: 0.2rem 0.5rem 0.2rem;
    overflow-x: scroll;
    scroll-behavior: smooth;
    scrollbar-width: auto;
    scrollbar-color: #007bff #e0e0e0;
    gap: 8px;
}

.zlPLmBBnFthk9a40aIzy {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 25%;
    font-size: 12px;
    line-height: 12px;
    font-weight: 400;
    color: #a5a5a5;
    border: none;
    outline: none;
    padding: 0.25rem;
    box-sizing: border-box;
    min-width: 68px;
    min-height: 76px;
    word-break: break-word;
    border-radius: 8px;
    padding: .5rem .2rem;
    box-shadow: 3px 6px 12px -4px rgba(0, 0, 0, .24);
    transition: transform .15s ease-in-out;
}

.zlPLmBBnFthk9a40aIzy span {
    font-size: 10px;
    color: #000;
}

.zlPLmBBnFthk9a40aIzy img {
    width: 50px;
    height: 50px;
    object-fit: contain;
}

.ZnoqZNprINC31QAqfnwW {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    cursor: pointer;
    display: inline-block;
    transform: scale(1.75);
    -webkit-transform: scale(1.75);
    -moz-transform: scale(1.75);
}

.ZnoqZNprINC31QAqfnwW.jm4mKjYFWJwFrzC4NMV0 {
    height: 15px;
    width: 15px;
    background-position: -19px 0px;
}

.ZnoqZNprINC31QAqfnwW.lWx60gpyG9qmvtTCsA_8 {
    width: 18px;
    height: 15px;
    background-position: 0px 0px;
}

.ZnoqZNprINC31QAqfnwW.z9iUpUqCAItzTPyhzEna {
    width: 15px;
    height: 14px;
    background-position: -35px 0px;
}

.dRyp30EamTHRVk9wX3Ot {
    border-radius: 6px;
    filter: drop-shadow(2px 3px 5px rgba(0, 0, 0, 0.15));
}

.dRyp30EamTHRVk9wX3Ot .gmc6XOWqBWFew49g_EHw {
    height: 42px;
    width: 42px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.nM9CTaNVKf9x7lPoGuCt {
    background: #ece5f4;
}

.W1NTVNDYLkJBlx5ZwpVw {
    background: #fdebe9;
}

.nZW5VLICvuwZaARebSGj {
    background: #e5f5fc;
}

.qT5T8dDpF3O6WpkuJDdj {
    position: relative;
    text-align: center;
    z-index: 9;
    display: inline-flex;
    width: 100%;
    justify-content: center;
    margin: 8px 0px;
}

.qT5T8dDpF3O6WpkuJDdj p {
    font-family: Metropolis;
    font-size: 10px;
    text-align: center;
    background: white;
    display: inline-block;
    padding: 0.4rem;
    z-index: auto !important;
    border: 1px solid rgba(228, 232, 235, 1);
    border-radius: 8px;
    color: #cdcdcd;
}

.qT5T8dDpF3O6WpkuJDdj p:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 1px;
    background: #cdcdcd;
    left: 0;
    z-index: -1;
    top: 12px;
}

.c7cahbaPtN8xlzzX6N5y {
    padding: 0 0.25rem;
}

.yy3QBf5yZd4jet9RgO6M {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    width: fit-content;
    position: static;
    max-width: 540px;
    width: 100%;
    background: white;
    position: relative;

}

.yy3QBf5yZd4jet9RgO6M .Qx0AlH5uC7u4jLidyS1Y {
    font-size: 10px;
    color: #697687;
    position: absolute;
    top: -0.5rem;
    margin: 0 0 0 12px;
    padding: 2px 4px;
    background: white;
    width: fit-content;
    border-radius: 6px;
}

.yy3QBf5yZd4jet9RgO6M .WWz1rwrq1mv0NFQYC2CG {
    padding: 10px 70px 10px 6px;
    font-size: 12px;
    border: 1px solid rgba(64, 80, 101, 1);
    border-radius: 8px;
    background: white;
}

.yy3QBf5yZd4jet9RgO6M .WWz1rwrq1mv0NFQYC2CG:focus {
    outline: none;
}

.eNyBECZ2VNn8EOD5FEoI {
    font-family: "Metropolis";
    display: inline-block;
    position: absolute;
    right: 6px;
    top: 6px;
    padding: 6px 12px;
    border-radius: 4px;
    color: white;
    background: rgba(3, 182, 150, 1);
    border: none;
    font-weight: 500;
    font-size: 12px;
}
.lpQJVfEK6t8V0PqI11eX {
    display: flex;
    flex-direction: column;
    padding-bottom: 1rem;
}

.NTUhSv9w_ldJAFkZyfgM {
    position: relative;
    width: 100%;
    border: 0;
    background-color: #000;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem;
    font-family: "Metropolis";
    font-weight: 500;
    min-height: 50px;
    border-radius: 6px !important;
    color: white;
    letter-spacing: 0.5px;
    font-size: 13px;
    gap: 0.5rem;
}

.NTUhSv9w_ldJAFkZyfgM[disabled],
.NTUhSv9w_ldJAFkZyfgM.WE4IzWkQY0pCuep_mNMw {
    opacity: 0.4;
    background: gray !important;
    cursor: none;
    pointer-events: none;
}

.NTUhSv9w_ldJAFkZyfgM.FfkWh0tmTwx0xSQRLT9k {
    opacity: 0.4;
    background: gray !important;
    pointer-events: initial;
    cursor: pointer;
}

.NTUhSv9w_ldJAFkZyfgM.WhGDViISEnQ0lGDRGvxo {
    background: #0e9343 !important;
}

.NTUhSv9w_ldJAFkZyfgM .KI6hXGKtkfi3FLPE5mRs {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
}

.NTUhSv9w_ldJAFkZyfgM .KI6hXGKtkfi3FLPE5mRs .EYvM_eEq3ZcKb4ZxuvIa {
    display: flex;
    flex-direction: column;
    text-align: left;
    font-size: 16px;
    line-height: 16px;
}

.NTUhSv9w_ldJAFkZyfgM .KI6hXGKtkfi3FLPE5mRs .EYvM_eEq3ZcKb4ZxuvIa .fOjrIF4h_4myTkgpePio {
    font-size: small;
    margin-top: 0.1rem;
}

.NTUhSv9w_ldJAFkZyfgM .KI6hXGKtkfi3FLPE5mRs .EYvM_eEq3ZcKb4ZxuvIa .PUgxPj31BVwT85QuYJLT {
    font-size: 10px;
    margin-top: 2px;
    line-height: 1;
}

.NTUhSv9w_ldJAFkZyfgM .KI6hXGKtkfi3FLPE5mRs .DX1kJPF9pPrk0lb1FjMw {
    text-align: left;
    font-size: 12px;
    margin-top: 2px;
    line-height: 1;
}

.NTUhSv9w_ldJAFkZyfgM .fsLOdANtgZTVUAoJLc7W img:first-child {
    max-height: 26px;
}

.NTUhSv9w_ldJAFkZyfgM.IDMdZ2orwXD79BnRVXxf .KI6hXGKtkfi3FLPE5mRs .EYvM_eEq3ZcKb4ZxuvIa .PUgxPj31BVwT85QuYJLT {
    display: block;
}

.fDtvmELr0yKw95esteln {
    display: flex;
    align-items: center;
    gap: 0.25rem;
}


.C6tvfCOGao45g2AH7kvw {
    text-align: left;
    display: flex;
    flex-direction: column;
    color: inherit;
}

.PK7GeTqzTT3HFBCxeXSW {
    border: none;
    background: white !important;
    color: #101828 !important;
    border-bottom: 1.2px dashed #d0d5dd;
    border-radius: 0 !important;
    margin-bottom: 0;
}

.HxMahS9f5F_MSW6NwKgC {
    font-size: 0.75rem;
    display: flex;
    align-items: center;
    gap: 0.25rem;
    color: inherit;
}

.c14ejgKFkV6zNiNxc__9 {
    display: flex;
    flex-direction: column;
}

.RRIJz_JW7obE1mlhbkiG {
    font-size: 10px;
    text-align: left;
    text-decoration: line-through;
}

.dGiBONKNKQGhVgDuTg8B {
    width: 1.3rem;
    height: 1.4rem;
    overflow: hidden;
    transform: scale(0.9);
}

.Jux7w1OSl0tKbgWVtU2n {
    position: sticky;
    top: 0;
    z-index: 10;
}

.f95EtA9T3Uq9Eq0hmyg4 {
    line-height: 10px;
    display: flex;
    position: absolute;
    top: -2px;
    left: -6px;
    width: max-content;
    max-width: 100%;
}

.f95EtA9T3Uq9Eq0hmyg4 .lUzaOMSvuvz1maSL2Z6g {
    display: none;
}

.f95EtA9T3Uq9Eq0hmyg4 .BnoqZYbXUWa5_KeEWhxD::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.25);
}

.f95EtA9T3Uq9Eq0hmyg4 .BnoqZYbXUWa5_KeEWhxD {
    position: absolute;
    top: 13px;
    background: rgba(3, 182, 150, 1);
    width: 5px;
    height: 4px;
    border-bottom-left-radius: 28px;
}

.f95EtA9T3Uq9Eq0hmyg4 .zYHYjN5RP_oH9di9qe9w {
    box-shadow: 0px 4px 4px -4px rgba(0, 0, 0, 0.6);
    background: rgba(3, 182, 150, 1);
    width: 100%;
    padding: 2px 6px 2px 6px;
    border-radius: 4px 4px 4px 0px;
    color: white;
    font-size: 7px;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-family: "Metropolis";
}

.XM75hIVuHlGhRO70kZ_K {
    display: flex;
    position: absolute;
    top: 0.5px;
    left: 50%;
    transform: translate(-50%, -50%);
    width: max-content;
    max-width: 100%;
}

.XM75hIVuHlGhRO70kZ_K .BnoqZYbXUWa5_KeEWhxD,
.XM75hIVuHlGhRO70kZ_K .lUzaOMSvuvz1maSL2Z6g {
    background: rgba(3, 182, 150, 1);
    width: 6px;
    height: 6px;
    position: relative;
}

.XM75hIVuHlGhRO70kZ_K .BnoqZYbXUWa5_KeEWhxD::after,
.XM75hIVuHlGhRO70kZ_K .lUzaOMSvuvz1maSL2Z6g::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.25);
}

.XM75hIVuHlGhRO70kZ_K .BnoqZYbXUWa5_KeEWhxD,
.XM75hIVuHlGhRO70kZ_K .BnoqZYbXUWa5_KeEWhxD::after {
    border-top-left-radius: 28px;
}

.XM75hIVuHlGhRO70kZ_K .lUzaOMSvuvz1maSL2Z6g,
.XM75hIVuHlGhRO70kZ_K .lUzaOMSvuvz1maSL2Z6g::after {
    border-top-right-radius: 28px;
}

.XM75hIVuHlGhRO70kZ_K .zYHYjN5RP_oH9di9qe9w {
    box-shadow: 0px 4px 4px -4px rgba(0, 0, 0, 0.6);
    background: rgba(3, 182, 150, 1);
    width: 100%;
    padding: 2px 8px 2px 8px;
    border-radius: 0px 0px 6px 6px;
    color: white;
    font-size: 7px;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-family: "Metropolis";
}

.PUgxPj31BVwT85QuYJLT {
    font-size: 9px;
    padding-top: 2px;
    font-family: "Metropolis";
    font-weight: 600;
}

.VGCpE1saq2eTZzAubUJI {
    position: sticky !important;
    bottom: 0;
    left: 0;
    z-index: 10;
}

.omKRcEDYToGaR_Zvconm {
    position: absolute !important;
    bottom: 0;
    left: 0;
    z-index: 10;
}
.hnk5qFgTwg6JZOsz5Jky {
    display: flex;
    flex-direction: column;
}
.baw7dFo5xpCseWUA51Yb {
    font-size: 12px;
    white-space: nowrap;
}
.GpU7l7Ie5HVr6Fh5Jpi_ {
    font-size: 9px;
    text-align: left;
}


@keyframes VkA2EanPe4L_2mZVqwlq {
    0% {
        opacity: 1;
        transform: scale(1);
    }
    100% {
        opacity: 0;
        transform: scale(0);
        filter: blur(20px);
        display: none;
    }
}

.Li_2hWCkA_4HfkC5Ol3E {
    animation: VkA2EanPe4L_2mZVqwlq 0.5s ease-in forwards;
}

.XE0tonJ6sP26j0Yo3Gr5 {
    animation: XE0tonJ6sP26j0Yo3Gr5 0.2s ease-in forwards;
    z-index: 30
}

@keyframes XE0tonJ6sP26j0Yo3Gr5 {
    0% {
        opacity: 0;
        transform: scale(0);
    }
    100% {
        opacity: 1;
        transform: scale(1);
    }
}

.rj0rvBYJ1jd6Q73dNCDL {
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.nUkyaP6AEaxjHTIf0eDF {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 10;
}

.cRiqADsrrXTIj4vkNKXg {
    flex: 1;
}`, "",{"version":3,"sources":["webpack://./src/library/components/simulator/simulator.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;IACrB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,qBAAqB;IACrB,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,qCAAqC;IACrC,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,cAAc;AAClB;;;AAGA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,kCAAkC;IAClC,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,kBAAkB;IAClB,uBAAuB;IACvB,qBAAqB;IACrB,gCAAgC;IAChC,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,oBAAoB;IACpB,gDAAgD;IAChD,sCAAsC;AAC1C;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,yDAAsD;IACtD,4BAA4B;IAC5B,eAAe;IACf,qBAAqB;IACrB,sBAAsB;IACtB,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,oDAAoD;AACxD;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,oBAAoB;IACpB,WAAW;IACX,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;IACrB,eAAe;IACf,wBAAwB;IACxB,wCAAwC;IACxC,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,OAAO;IACP,WAAW;IACX,SAAS;AACb;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;;AAEtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,sCAAsC;IACtC,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,gCAAgC;IAChC,YAAY;IACZ,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,sBAAsB;IACtB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,6BAA6B;IAC7B,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,WAAW;AACf;;AAEA;;IAEI,YAAY;IACZ,2BAA2B;IAC3B,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,2BAA2B;IAC3B,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;;AAGA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,4BAA4B;IAC5B,yBAAyB;IACzB,mCAAmC;IACnC,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,gCAAgC;IAChC,UAAU;IACV,WAAW;IACX,+BAA+B;AACnC;;AAEA;IACI,+CAA+C;IAC/C,gCAAgC;IAChC,WAAW;IACX,wBAAwB;IACxB,8BAA8B;IAC9B,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,gCAAgC;IAChC,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;IAEI,gCAAgC;IAChC,UAAU;IACV,WAAW;IACX,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,qCAAqC;AACzC;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;IACI,+CAA+C;IAC/C,gCAAgC;IAChC,WAAW;IACX,wBAAwB;IACxB,8BAA8B;IAC9B,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,SAAS;IACT,OAAO;IACP,WAAW;AACf;;AAEA;IACI,6BAA6B;IAC7B,SAAS;IACT,OAAO;IACP,WAAW;AACf;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,gBAAgB;AACpB;;;AAGA;IACI;QACI,UAAU;QACV,mBAAmB;IACvB;IACA;QACI,UAAU;QACV,mBAAmB;QACnB,kBAAkB;QAClB,aAAa;IACjB;AACJ;;AAEA;IACI,qDAAwC;AAC5C;;AAEA;IACI,qDAAuC;IACvC;AACJ;;AAEA;IACI;QACI,UAAU;QACV,mBAAmB;IACvB;IACA;QACI,UAAU;QACV,mBAAmB;IACvB;AACJ;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,WAAW;AACf;;AAEA;IACI,OAAO;AACX","sourcesContent":[".simulatorWrapper {\n    width: 100%;\n    height: 100%;\n    box-sizing: border-box;\n    background-color: white;\n    padding: 0.25rem;\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    max-width: 430px;\n}\n\n.previewContainer {\n    text-align: center;\n}\n\n.simulatorContainer {\n    position: relative;\n    height: 640px;\n    border-width: 2px;\n    border-style: solid;\n    border-color: #dedede;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    border-radius: 1rem;\n    overflow-y: auto;\n    background-color: #f9f9f9;\n}\n\n.previewTitle {\n    margin: 0;\n    margin-top: 0.25rem;\n    padding: 0.25rem;\n}\n\n.simulatorBody {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    padding-left: 0.65rem;\n    padding-right: 0.65rem;\n    margin-bottom: 0.5rem;\n}\n\n.paymentsHeader {\n    display: block;\n    font-size: 16px;\n    line-height: 22px;\n    letter-spacing: 0.5px;\n    align-items: center;\n    color: #101828;\n    font-family: \"Metropolis\";\n    font-weight: 600;\n}\n\n.paymentsSubHeader {\n    font-size: 11px;\n    font-family: 'Metropolis', sans-serif;\n    font-weight: 500;\n    line-height: 1rem;\n    padding-bottom: 0.25rem;\n    color: #000000;\n}\n\n\n.pspPanel {\n    box-sizing: border-box;\n    border-radius: 12px;\n    background: rgba(255, 255, 255, 1);\n    border: 1px solid #eaecf0;\n    position: relative;\n    padding-bottom: 0.5rem;\n}\n\n.pspPanelHeader {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 1rem 0.675rem 0.5rem 0.675rem;\n}\n\n.label {\n    display: flex;\n    gap: 4px;\n    font-weight: 600;\n}\n\n.label .icon {\n    max-height: 23px;\n    max-width: 20px;\n    overflow: hidden;\n}\n\n.label .title {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n    font-size: 13px;\n    text-align: left;\n}\n\n.pspPriceContainer {\n    font-size: 0.8rem;\n    display: flex;\n    align-items: end;\n    gap: 0.25rem;\n    color: inherit;\n}\n\n.priceComparison {\n    display: flex;\n    flex-direction: column;\n}\n\n.strikethrough {\n    font-size: 10px;\n    text-align: left;\n    text-decoration: line-through;\n}\n\n.paymentIcon {\n    width: 0.7rem;\n    height: 1rem;\n    overflow: hidden;\n    transform: scale(0.85);\n}\n\n.upiWrapper {\n    background: white;\n    border-radius: 8px;\n    padding-bottom: 0.5rem;\n}\n\n.pspWrappers {\n    display: flex;\n    padding: 0.2rem 0.5rem 0.2rem;\n    overflow-x: scroll;\n    scroll-behavior: smooth;\n    scrollbar-width: auto;\n    scrollbar-color: #007bff #e0e0e0;\n    gap: 8px;\n}\n\n.pspBtn {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    width: 25%;\n    font-size: 12px;\n    line-height: 12px;\n    font-weight: 400;\n    color: #a5a5a5;\n    border: none;\n    outline: none;\n    padding: 0.25rem;\n    box-sizing: border-box;\n    min-width: 68px;\n    min-height: 76px;\n    word-break: break-word;\n    border-radius: 8px;\n    padding: .5rem .2rem;\n    box-shadow: 3px 6px 12px -4px rgba(0, 0, 0, .24);\n    transition: transform .15s ease-in-out;\n}\n\n.pspBtn span {\n    font-size: 10px;\n    color: #000;\n}\n\n.pspBtn img {\n    width: 50px;\n    height: 50px;\n    object-fit: contain;\n}\n\n.spriteIcons {\n    background-image: url('../../images/common/icons.svg');\n    background-repeat: no-repeat;\n    cursor: pointer;\n    display: inline-block;\n    transform: scale(1.75);\n    -webkit-transform: scale(1.75);\n    -moz-transform: scale(1.75);\n}\n\n.spriteIcons.phonepe-icon {\n    height: 15px;\n    width: 15px;\n    background-position: -19px 0px;\n}\n\n.spriteIcons.tez-icon {\n    width: 18px;\n    height: 15px;\n    background-position: 0px 0px;\n}\n\n.spriteIcons.paytm-icon {\n    width: 15px;\n    height: 14px;\n    background-position: -35px 0px;\n}\n\n.borderView {\n    border-radius: 6px;\n    filter: drop-shadow(2px 3px 5px rgba(0, 0, 0, 0.15));\n}\n\n.borderView .img {\n    height: 42px;\n    width: 42px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.phonepeBg {\n    background: #ece5f4;\n}\n\n.tezBg {\n    background: #fdebe9;\n}\n\n.paytmBg {\n    background: #e5f5fc;\n}\n\n.orOption {\n    position: relative;\n    text-align: center;\n    z-index: 9;\n    display: inline-flex;\n    width: 100%;\n    justify-content: center;\n    margin: 8px 0px;\n}\n\n.orOption p {\n    font-family: Metropolis;\n    font-size: 10px;\n    text-align: center;\n    background: white;\n    display: inline-block;\n    padding: 0.4rem;\n    z-index: auto !important;\n    border: 1px solid rgba(228, 232, 235, 1);\n    border-radius: 8px;\n    color: #cdcdcd;\n}\n\n.orOption p:after {\n    content: '';\n    position: absolute;\n    width: 100%;\n    height: 1px;\n    background: #cdcdcd;\n    left: 0;\n    z-index: -1;\n    top: 12px;\n}\n\n.collectWrapper {\n    padding: 0 0.25rem;\n}\n\n.customInput {\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    width: fit-content;\n    position: static;\n    max-width: 540px;\n    width: 100%;\n    background: white;\n    position: relative;\n\n}\n\n.customInput .text {\n    font-size: 10px;\n    color: #697687;\n    position: absolute;\n    top: -0.5rem;\n    margin: 0 0 0 12px;\n    padding: 2px 4px;\n    background: white;\n    width: fit-content;\n    border-radius: 6px;\n}\n\n.customInput .input {\n    padding: 10px 70px 10px 6px;\n    font-size: 12px;\n    border: 1px solid rgba(64, 80, 101, 1);\n    border-radius: 8px;\n    background: white;\n}\n\n.customInput .input:focus {\n    outline: none;\n}\n\n.collectBtn {\n    font-family: \"Metropolis\";\n    display: inline-block;\n    position: absolute;\n    right: 6px;\n    top: 6px;\n    padding: 6px 12px;\n    border-radius: 4px;\n    color: white;\n    background: rgba(3, 182, 150, 1);\n    border: none;\n    font-weight: 500;\n    font-size: 12px;\n}\n.paymentBtnsContainer {\n    display: flex;\n    flex-direction: column;\n    padding-bottom: 1rem;\n}\n\n.paymentBtn {\n    position: relative;\n    width: 100%;\n    border: 0;\n    background-color: #000;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0.5rem;\n    font-family: \"Metropolis\";\n    font-weight: 500;\n    min-height: 50px;\n    border-radius: 6px !important;\n    color: white;\n    letter-spacing: 0.5px;\n    font-size: 13px;\n    gap: 0.5rem;\n}\n\n.paymentBtn[disabled],\n.paymentBtn.disabled {\n    opacity: 0.4;\n    background: gray !important;\n    cursor: none;\n    pointer-events: none;\n}\n\n.paymentBtn.disabledClick {\n    opacity: 0.4;\n    background: gray !important;\n    pointer-events: initial;\n    cursor: pointer;\n}\n\n.paymentBtn.greenBackground {\n    background: #0e9343 !important;\n}\n\n.paymentBtn .info {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 2px;\n}\n\n.paymentBtn .info .title {\n    display: flex;\n    flex-direction: column;\n    text-align: left;\n    font-size: 16px;\n    line-height: 16px;\n}\n\n.paymentBtn .info .title .smallBtnText {\n    font-size: small;\n    margin-top: 0.1rem;\n}\n\n.paymentBtn .info .title .subtext {\n    font-size: 10px;\n    margin-top: 2px;\n    line-height: 1;\n}\n\n.paymentBtn .info .codSubtext {\n    text-align: left;\n    font-size: 12px;\n    margin-top: 2px;\n    line-height: 1;\n}\n\n.paymentBtn .icon img:first-child {\n    max-height: 26px;\n}\n\n.paymentBtn.btnPpcod .info .title .subtext {\n    display: block;\n}\n\n.paymentButtonWrapper {\n    display: flex;\n    align-items: center;\n    gap: 0.25rem;\n}\n\n\n.paymentText {\n    text-align: left;\n    display: flex;\n    flex-direction: column;\n    color: inherit;\n}\n\n.alternateUi {\n    border: none;\n    background: white !important;\n    color: #101828 !important;\n    border-bottom: 1.2px dashed #d0d5dd;\n    border-radius: 0 !important;\n    margin-bottom: 0;\n}\n\n.priceWrapper {\n    font-size: 0.75rem;\n    display: flex;\n    align-items: center;\n    gap: 0.25rem;\n    color: inherit;\n}\n\n.priceContainer {\n    display: flex;\n    flex-direction: column;\n}\n\n.comparedPrice {\n    font-size: 10px;\n    text-align: left;\n    text-decoration: line-through;\n}\n\n.paymentIconContainer {\n    width: 1.3rem;\n    height: 1.4rem;\n    overflow: hidden;\n    transform: scale(0.9);\n}\n\n.fixedHeader {\n    position: sticky;\n    top: 0;\n    z-index: 10;\n}\n\n.btnDiscountBadge {\n    line-height: 10px;\n    display: flex;\n    position: absolute;\n    top: -2px;\n    left: -6px;\n    width: max-content;\n    max-width: 100%;\n}\n\n.btnDiscountBadge .right {\n    display: none;\n}\n\n.btnDiscountBadge .left::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.25);\n}\n\n.btnDiscountBadge .left {\n    position: absolute;\n    top: 13px;\n    background: rgba(3, 182, 150, 1);\n    width: 5px;\n    height: 4px;\n    border-bottom-left-radius: 28px;\n}\n\n.btnDiscountBadge .badgeContent {\n    box-shadow: 0px 4px 4px -4px rgba(0, 0, 0, 0.6);\n    background: rgba(3, 182, 150, 1);\n    width: 100%;\n    padding: 2px 6px 2px 6px;\n    border-radius: 4px 4px 4px 0px;\n    color: white;\n    font-size: 7px;\n    font-weight: 600;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    font-family: \"Metropolis\";\n}\n\n.oldBtnDiscountBadge {\n    display: flex;\n    position: absolute;\n    top: 0.5px;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: max-content;\n    max-width: 100%;\n}\n\n.oldBtnDiscountBadge .left,\n.oldBtnDiscountBadge .right {\n    background: rgba(3, 182, 150, 1);\n    width: 6px;\n    height: 6px;\n    position: relative;\n}\n\n.oldBtnDiscountBadge .left::after,\n.oldBtnDiscountBadge .right::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.25);\n}\n\n.oldBtnDiscountBadge .left,\n.oldBtnDiscountBadge .left::after {\n    border-top-left-radius: 28px;\n}\n\n.oldBtnDiscountBadge .right,\n.oldBtnDiscountBadge .right::after {\n    border-top-right-radius: 28px;\n}\n\n.oldBtnDiscountBadge .badgeContent {\n    box-shadow: 0px 4px 4px -4px rgba(0, 0, 0, 0.6);\n    background: rgba(3, 182, 150, 1);\n    width: 100%;\n    padding: 2px 8px 2px 8px;\n    border-radius: 0px 0px 6px 6px;\n    color: white;\n    font-size: 7px;\n    font-weight: 600;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    font-family: \"Metropolis\";\n}\n\n.subtext {\n    font-size: 9px;\n    padding-top: 2px;\n    font-family: \"Metropolis\";\n    font-weight: 600;\n}\n\n.stickyFooter {\n    position: sticky !important;\n    bottom: 0;\n    left: 0;\n    z-index: 10;\n}\n\n.fixedFooter {\n    position: absolute !important;\n    bottom: 0;\n    left: 0;\n    z-index: 10;\n}\n.bnplPrice {\n    display: flex;\n    flex-direction: column;\n}\n.bnplSubtext {\n    font-size: 12px;\n    white-space: nowrap;\n}\n.bnplEmiSubtext {\n    font-size: 9px;\n    text-align: left;\n}\n\n\n@keyframes fadeOut {\n    0% {\n        opacity: 1;\n        transform: scale(1);\n    }\n    100% {\n        opacity: 0;\n        transform: scale(0);\n        filter: blur(20px);\n        display: none;\n    }\n}\n\n.animateFadeOut {\n    animation: fadeOut 0.5s ease-in forwards;\n}\n\n.fadeIn {\n    animation: fadeIn 0.2s ease-in forwards;\n    z-index: 30\n}\n\n@keyframes fadeIn {\n    0% {\n        opacity: 0;\n        transform: scale(0);\n    }\n    100% {\n        opacity: 1;\n        transform: scale(1);\n    }\n}\n\n.contentWrapper {\n    position: relative;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.4);\n    z-index: 10;\n}\n\n.customScreen {\n    flex: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"simulatorWrapper": `D9DWeQ6vl26go5aEPQro`,
	"previewContainer": `dpCPxzE5HTyFWPOxQtDQ`,
	"simulatorContainer": `G4FKZ5da2A7yrkGWDEix`,
	"previewTitle": `sEJkCycmk5b1OyetRw4K`,
	"simulatorBody": `orhOQFkVQCn95ohirr24`,
	"paymentsHeader": `A3rjX5eCVNYkauQiOpWT`,
	"paymentsSubHeader": `y54A11MhSaIVi5Mr315E`,
	"pspPanel": `Ap677P7vecKEtQx7kbPM`,
	"pspPanelHeader": `zDHFAYa5ECa16AfBvGPH`,
	"label": `BGuZZqt6D1__g0TUjRD5`,
	"icon": `fsLOdANtgZTVUAoJLc7W`,
	"title": `EYvM_eEq3ZcKb4ZxuvIa`,
	"pspPriceContainer": `U0ywxzShWByb0EqWeDIQ`,
	"priceComparison": `iFrIGiyZWXtfzzHWIolk`,
	"strikethrough": `mJbUqtDQwPWMUbApCQYJ`,
	"paymentIcon": `HqYT8bZZB9iZggDTVmak`,
	"upiWrapper": `bAEDwJv1xxKkiHdLTK8r`,
	"pspWrappers": `_Muhqa_ya7ekdsu68zdQ`,
	"pspBtn": `zlPLmBBnFthk9a40aIzy`,
	"spriteIcons": `ZnoqZNprINC31QAqfnwW`,
	"phonepe-icon": `jm4mKjYFWJwFrzC4NMV0`,
	"tez-icon": `lWx60gpyG9qmvtTCsA_8`,
	"paytm-icon": `z9iUpUqCAItzTPyhzEna`,
	"borderView": `dRyp30EamTHRVk9wX3Ot`,
	"img": `gmc6XOWqBWFew49g_EHw`,
	"phonepeBg": `nM9CTaNVKf9x7lPoGuCt`,
	"tezBg": `W1NTVNDYLkJBlx5ZwpVw`,
	"paytmBg": `nZW5VLICvuwZaARebSGj`,
	"orOption": `qT5T8dDpF3O6WpkuJDdj`,
	"collectWrapper": `c7cahbaPtN8xlzzX6N5y`,
	"customInput": `yy3QBf5yZd4jet9RgO6M`,
	"text": `Qx0AlH5uC7u4jLidyS1Y`,
	"input": `WWz1rwrq1mv0NFQYC2CG`,
	"collectBtn": `eNyBECZ2VNn8EOD5FEoI`,
	"paymentBtnsContainer": `lpQJVfEK6t8V0PqI11eX`,
	"paymentBtn": `NTUhSv9w_ldJAFkZyfgM`,
	"disabled": `WE4IzWkQY0pCuep_mNMw`,
	"disabledClick": `FfkWh0tmTwx0xSQRLT9k`,
	"greenBackground": `WhGDViISEnQ0lGDRGvxo`,
	"info": `KI6hXGKtkfi3FLPE5mRs`,
	"smallBtnText": `fOjrIF4h_4myTkgpePio`,
	"subtext": `PUgxPj31BVwT85QuYJLT`,
	"codSubtext": `DX1kJPF9pPrk0lb1FjMw`,
	"btnPpcod": `IDMdZ2orwXD79BnRVXxf`,
	"paymentButtonWrapper": `fDtvmELr0yKw95esteln`,
	"paymentText": `C6tvfCOGao45g2AH7kvw`,
	"alternateUi": `PK7GeTqzTT3HFBCxeXSW`,
	"priceWrapper": `HxMahS9f5F_MSW6NwKgC`,
	"priceContainer": `c14ejgKFkV6zNiNxc__9`,
	"comparedPrice": `RRIJz_JW7obE1mlhbkiG`,
	"paymentIconContainer": `dGiBONKNKQGhVgDuTg8B`,
	"fixedHeader": `Jux7w1OSl0tKbgWVtU2n`,
	"btnDiscountBadge": `f95EtA9T3Uq9Eq0hmyg4`,
	"right": `lUzaOMSvuvz1maSL2Z6g`,
	"left": `BnoqZYbXUWa5_KeEWhxD`,
	"badgeContent": `zYHYjN5RP_oH9di9qe9w`,
	"oldBtnDiscountBadge": `XM75hIVuHlGhRO70kZ_K`,
	"stickyFooter": `VGCpE1saq2eTZzAubUJI`,
	"fixedFooter": `omKRcEDYToGaR_Zvconm`,
	"bnplPrice": `hnk5qFgTwg6JZOsz5Jky`,
	"bnplSubtext": `baw7dFo5xpCseWUA51Yb`,
	"bnplEmiSubtext": `GpU7l7Ie5HVr6Fh5Jpi_`,
	"animateFadeOut": `Li_2hWCkA_4HfkC5Ol3E`,
	"fadeOut": `VkA2EanPe4L_2mZVqwlq`,
	"fadeIn": `XE0tonJ6sP26j0Yo3Gr5`,
	"contentWrapper": `rj0rvBYJ1jd6Q73dNCDL`,
	"overlay": `nUkyaP6AEaxjHTIf0eDF`,
	"customScreen": `cRiqADsrrXTIj4vkNKXg`
};
export default ___CSS_LOADER_EXPORT___;
